
























































































































































import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import XButton from '@/components/atoms/Button/XButton.vue'
import XButtonGroup from '@/components/atoms/ButtonGroup/XButtonGroup.vue'
import XCard from '@/components/atoms/Card/XCard.vue'
import XInput from '@/components/atoms/Input/XInput.vue'
import XForm from '@/components/atoms/Form/XForm.vue'
import XFormLabel from '@/components/atoms/FormLabel/XFormLabel.vue'
import XBirthdayPicker from '@/components/atoms/BirthdayPicker/XBirthdayPicker.vue'
import { Gender } from '@/store/types'
import { UpdateProfileInput, User } from '@/types/generated/graphql'

interface DataType {
  input: Partial<UpdateProfileInput>
  Gender: typeof Gender
}

export default Vue.extend({
  name: 'ProfileEdit',
  components: {
    XCard,
    XButton,
    XButtonGroup,
    XInput,
    XForm,
    XFormLabel,
    XBirthdayPicker,
  },
  data(): DataType {
    return {
      input: {
        firstName: undefined,
        lastName: undefined,
        firstNameKana: undefined,
        lastNameKana: undefined,
        birthday: undefined,
        gender: undefined,
        height: undefined,
        weight: undefined,
      },
      Gender,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
  },
  methods: {
    ...mapActions('auth', ['updateProfile']),
    async onSubmit() {
      const value = {
        ...this.input,
      } as UpdateProfileInput
      await this.updateProfile(value)
      this.$router.back()
    },
  },
  mounted() {
    const { profile } = this.user as User
    this.input = {
      firstName: profile.firstName,
      lastName: profile.lastName,
      firstNameKana: profile.firstNameKana,
      lastNameKana: profile.lastNameKana,
      birthday: profile.birthday,
      gender: profile.gender,
      height: profile.height,
      weight: profile.weight,
    }
  },
})
